// Shared branded chrome for the Arth Setuu Global umbrella.
// Yatra content is left completely untouched — this file is used ONLY by the new Umbrella, Jobs and Loans pages.
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin, Menu, X } from "lucide-react";
import { useState } from "react";

export const LOGO_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_pilgrimage-hub-test/artifacts/ko56o9zy_WhatsApp%20Image%202026-08-19%20at%207.07.24%20PM.jpeg";
export const PHONE = "8789299576";
export const WHATSAPP = "918789299576";
export const EMAIL_PRIMARY = "arthsetuuglobal@gmail.com";
export const EMAIL_SECONDARY = "yatra@arthsetuuglobal.in";
export const OFFICE_ADDRESS_LINES = [
  "2nd Floor, Office No. 2, Bandhu Market",
  "Opposite Aditya Vision, Tribhuvan More",
  "Khagaul Road, Danapur, Patna 801105"
];

// Vertical brand accents — cohesive but distinctive.
export const VERTICAL_THEMES = {
  umbrella: {
    key: "umbrella", name: "Arth Setuu Global", tagline: "Bridging Faith · Building Journeys",
    accent: "#B45309", accentSoft: "#FEF3C7", grad: "linear-gradient(135deg,#B45309 0%,#7C2D12 100%)"
  },
  yatra: {
    key: "yatra", name: "Yatra", tagline: "Spiritual & Pilgrimage Journeys",
    accent: "#B45309", accentSoft: "#FEF3C7", grad: "linear-gradient(135deg,#F59E0B 0%,#B45309 100%)"
  },
  jobs: {
    key: "jobs", name: "Jobs", tagline: "Careers with purpose",
    accent: "#1D4ED8", accentSoft: "#DBEAFE", grad: "linear-gradient(135deg,#3B82F6 0%,#1E3A8A 100%)"
  },
  loans: {
    key: "loans", name: "Loans", tagline: "Finance made simple",
    accent: "#0F7A4E", accentSoft: "#D1FAE5", grad: "linear-gradient(135deg,#10B981 0%,#053D28 100%)"
  }
};

export function VerticalHeader({ theme = VERTICAL_THEMES.umbrella, currentVertical }) {
  const [open, setOpen] = useState(false);
  const verticals = [
    { key: "yatra", label: "Yatra", to: "/yatra" },
    { key: "jobs", label: "Jobs", to: "/jobs" }
  ];
  return (
    <header className="asg-header" data-testid={`${theme.key}-header`}>
      <Link to="/" className="asg-brand" data-testid="asg-brand-home">
        <img src={LOGO_URL} alt="Arth Setuu Global" />
        <div>
          <b>Arth Setuu Global</b>
          <small style={{ color: theme.accent }}>{theme.tagline}</small>
        </div>
      </Link>
      <nav className={`asg-nav ${open ? "open" : ""}`} data-testid={`${theme.key}-nav`}>
        {verticals.map(v => (
          <Link
            key={v.key}
            to={v.to}
            data-testid={`nav-${v.key}`}
            className={currentVertical === v.key ? "active" : ""}
            style={currentVertical === v.key ? { color: theme.accent } : {}}
            onClick={() => setOpen(false)}
          >
            {v.label}
          </Link>
        ))}
      </nav>
      <div className="asg-header-actions">
        <a className="asg-phone" href={`tel:${PHONE}`} data-testid={`${theme.key}-header-phone`}>
          <Phone size={14} /> +91 {PHONE}
        </a>
        <a
          className="asg-wa-btn"
          style={{ background: theme.grad }}
          href={`https://wa.me/${WHATSAPP}`}
          target="_blank" rel="noreferrer"
          data-testid={`${theme.key}-header-whatsapp`}
        >
          <MessageCircle size={14} /> WhatsApp
        </a>
        <button className="asg-menu-btn" onClick={() => setOpen(!open)} data-testid={`${theme.key}-menu-toggle`} aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
}

export function VerticalFooter({ theme = VERTICAL_THEMES.umbrella }) {
  return (
    <footer className="asg-footer" data-testid={`${theme.key}-footer`}>
      <div className="asg-footer-inner">
        <div className="asg-footer-col asg-footer-brand">
          <img src={LOGO_URL} alt="Arth Setuu Global" />
          <b>Arth Setuu Global</b>
          <small>Bridging Faith · Building Journeys · Powering Finance & Careers</small>
          <div className="asg-footer-socials">
            <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noreferrer" aria-label="WhatsApp"><MessageCircle size={16} /></a>
            <a href={`mailto:${EMAIL_PRIMARY}`} aria-label="Email"><Mail size={16} /></a>
          </div>
        </div>
        <div className="asg-footer-col">
          <h5>Verticals</h5>
          <ul>
            <li><Link to="/yatra" data-testid="footer-vertical-yatra">Yatra — Pilgrim journeys</Link></li>
            <li><Link to="/jobs" data-testid="footer-vertical-jobs">Jobs — Career opportunities</Link></li>
            <li><Link to="/loans" data-testid="footer-vertical-loans">Loans — Financial assistance</Link></li>
          </ul>
        </div>
        <div className="asg-footer-col">
          <h5>Contact</h5>
          <div className="asg-footer-contact">
            <a href={`tel:${PHONE}`}><Phone size={14} /> +91 {PHONE}</a>
            <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noreferrer"><MessageCircle size={14} /> WhatsApp chat</a>
            <a href={`mailto:${EMAIL_PRIMARY}`}><Mail size={14} /> {EMAIL_PRIMARY}</a>
            <div><MapPin size={14} /> <span>{OFFICE_ADDRESS_LINES.map((l, i) => <span key={i} style={{ display: 'block' }}>{l}</span>)}</span></div>
          </div>
        </div>
      </div>
      <div className="asg-footer-bottom">
        <span>© 2026 Arth Setuu Global. All rights reserved.</span>
        <div>
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-and-conditions">Terms</Link>
          <Link to="/refund-cancellation-policy">Refund</Link>
          <Link to="/disclaimer">Disclaimer</Link>
        </div>
      </div>
    </footer>
  );
}
